class DOT {
  //armazena dados para formar uma string em DOT, que e o dado passado entre front e back
  constructor(states, transitions) {
    this.transitions = [];
    this.starts = [];
    this.end = [];
    this.states = [];
    this.statesPositions = [];
    this.objectStates = states;
    this.objectTransitions = transitions;
  }

  addTransition(current, future, symbol) {
    try {
      const symbols = String(symbol)
        .split(/\s*,\s*/)
        .map((s) => s.trim())
        .filter((s) => s.length > 0);

      for (let i = 0; i < symbols.length; i++) {
        const t = `${current}->${future}[label="${symbols[i]}"];`;
        this.transitions.push(t);
      }
    } catch (e) {
      alert(e);
    }
  }

  addStart(s) {
    //se o estado for apenas inicial
    // this.start = s + "[shape=diamond];";
    this.starts.push(s + "[shape=diamond];");
  }

  addStartEnd(se) {
    //se o estado for inicial e final
    // this.start = se + "[shape=Mdiamond];";
    this.starts.push(se + "[shape=Mdiamond];");
  }

  addEnd(e) {
    //se o estado for final
    this.end.push(e + "[shape=square];");
  }

  // addNormalState(s) {
  //   this.states.push(s + ";");
  //   this.statesPositions.push(
  //     s.state.text + `[pos="${s.state.x / 100},${s.state.y / 100}"];`
  //     //   s.state.text
  //   );
  // }
  addNormalState(s) {
    this.states.push(s + ";");
    this.statesPositions.push(
      s.text + `[pos="${s.x / 100},${s.y / 100}"];`
      //   s.state.text
    );
  }

  // toDotLanguage() {
  //   this.childs.forEach((machineElement) => {
  //     if (machineElement != null && machineElement.state.visible) {
  //       const typeElement = machineElement.constructor.name;
  //       if (typeElement === "State") {
  //         const { text } = machineElement.state;
  //         this.addNormalState(machineElement);
  //         if (machineElement.state.isFinal && machineElement.state.isInitial) {
  //           this.addStartEnd(text);
  //         } else if (machineElement.state.isFinal) {
  //           this.addEnd(text);
  //         } else if (machineElement.state.isInitial) {
  //           this.addStart(text);
  //         }
  //       } else if (typeElement === "Transition") {
  //         const { initial, final, text } = machineElement.state;
  //         this.addTransition(initial.text, final.text, text);
  //       }
  //     }
  //   });
  // }
  toDotLanguage() {
    this.objectStates.forEach((machineElement) => {
      if (machineElement != null && machineElement != undefined) {
        //     // if (typeElement === "State") {
        const { text } = machineElement;
        this.addNormalState(machineElement);
        if (machineElement.isFinal && machineElement.isInitial) {
          this.addStartEnd(text);
        } else if (machineElement.isFinal) {
          this.addEnd(text);
        } else if (machineElement.isInitial) {
          this.addStart(text);
        }
        // } else if (typeElement === "Transition") {
        //   const { initial, final, text } = machineElement.state;
        //   this.addTransition(initial.text, final.text, text);
        // }
      }
    });
    this.objectTransitions.forEach((machineElement) => {
      if (machineElement != null) {
        // if (typeElement === "State") {

        const { initial, final, label } = machineElement;
        this.addTransition(initial.text, final.text, label);
      }
    });
  }
  toString() {
    //forma a string DOT
    try {
      let ret = "digraph G {\n";
      for (let i = 0; i < this.states.length; i++) {
        ret += this.statesPositions[i] + "\n";
      }
      ret += "\n";
      for (let i = 0; i < this.transitions.length; i++) {
        ret += this.transitions[i] + "\n";
      }

      if (!this.transitions.length === 0) {
        for (let i = 0; i < this.states.length; i++) {
          ret += this.states[i] + "\n";
        }
      }

      // ret += "\n" + this.start + "\n";

      ret += "\n";
      for (let i = 0; i < this.starts.length; i++) {
        ret += this.starts[i] + "\n";
      }
      for (let i = 0; i < this.end.length; i++) {
        ret += this.end[i] + "\n";
      }
      ret += "}";
      return ret;
    } catch (e) {
      alert(e);
    }
  }
}
export default DOT;
